import http from './axiosConfig' //引入基础配置
import { newBaseUrl as baseUrl } from "./api";
let getData = {}

//行业资讯/知识库获取标签列表 获取行业资讯/知识库所有标签-- 张
getData.getTags = (data)=>{ 
    return http.get(baseUrl+"/one/tags/",{ params:data })
}
//新增行业资讯/知识库 -- 张
getData.addNews = (data)=>{ 
    return http.post(baseUrl+"/one/knows/",data)
}
//查询单个行业资讯/知识库 -- 张
getData.getNew = (pk,data)=>{ 
    return new Promise((resolve, reject) => {
      http.get(baseUrl+"/one/know/"+pk+'/',{ params:data }).then((res) => {
          if(res.data.code == 200){
              let xx = res.data.data
                xx.k_icon ? xx.k_icon = xx.k_icon.replace("/api", "/api/media"):xx.k_icon;
                res.data.data=xx
                resolve(res)
          }else{
              resolve(res)
          }
      }).catch((err) => {
          reject(err)
      });
    })
    // return http.get(baseUrl+"/one/know/"+pk+'/',{ params:data })
}
//修改单个行业资讯/知识库 -- 张
getData.editNew = (pk,data)=>{ 
    return http.put(baseUrl+"/one/know/"+pk+'/',data)
}
//删除单个行业资讯/知识库 -- 张
getData.deleteNew = (pk,data)=>{ 
    return http.delete(baseUrl+"/one/know/"+pk+'/',data)
}
//知识库获取导航目录 -- 张
getData.getCats = (data)=>{ 
    return http.get(baseUrl+"/one/cats/",{ params:data })
}
//新增知识库解决方案 -- 张
getData.addSols = (data)=>{ 
    return http.post(baseUrl+"/one/sols/",data)
}

//修改知识库解决方案 -- 张
getData.editSols = (pk,data)=>{ 
    return http.put(baseUrl+"/one/sol/"+pk+"/",data)
}

// ========================后台行业资讯/知识库标签导航管理==========================
//获取单个父级下的所有标签 -- 张
getData.getFatherTags = (pk,data)=>{ 
    return http.get(baseUrl+"/one/tag/"+pk+"/",{ params:data })
}
//添加最子集标签 -- 张
getData.addTags = (data)=>{ 
    return http.post(baseUrl+"/one/tags/",data)
}
//修改最子集标签 -- 张
getData.editTag = (pk,data)=>{ 
    return http.patch(baseUrl+"/one/tag/"+pk+"/",data)
}
//删除最子集标签 -- 张
getData.deleteTag = (pk,data)=>{ 
    return http.delete(baseUrl+"/one/tag/"+pk+"/",data)
}
//批量删除最子集标签 -- 张
getData.deleteTags = (pk,data)=>{ 
    return http.delete(baseUrl+"/one/tags/multi_del/?ids="+pk,data)
}
//按照名称搜索查询标签 -- 张
getData.selectTags = (pk,data)=>{ 
    return http.get(baseUrl+"/one/tags/filter/?tag_name="+pk,data)
}




//获取知识库所有导航 -- 张
getData.getCats = (data)=>{ 
    return http.get(baseUrl+"/one/cats/",{ params:data })
}
//获取单个父级下的所有子导航 -- 张
getData.getFatherCats = (pk,data)=>{ 
    return http.get(baseUrl+"/one/cat/"+pk+"/",{ params:data })
}
//知识库添加最子集导航 -- 张
getData.addCats = (data)=>{ 
    return http.post(baseUrl+"/one/cats/",data)
}
//知识库修改最子集导航 -- 张
getData.editCat = (pk,data)=>{ 
    return http.patch(baseUrl+"/one/cat/"+pk+"/",data)
}
//知识库删除最子集导航 -- 张 
getData.deleteCat = (pk,data)=>{ 
    return http.delete(baseUrl+"/one/cat/"+pk+"/",data)
}
//批量删除最子集导航 -- 张
getData.deleteCats = (pk,data)=>{ 
    return http.delete(baseUrl+"/one/cats/multi_del/?ids="+pk,data)
}
//按照名称搜索查询导航 -- 张
getData.selectCats = (pk,data)=>{ 
    return http.get(baseUrl+"/one/cats/filter/?name="+pk,data)
}

//=============================行业资讯/知识库前端显示部分接口==================================
//前端获取行业资讯全部内容 -- 张
getData.getFrontNews = (pk,pagesize,page,data)=>{ 
    return http.get(baseUrl+"/one/front_knows/?k_type="+pk+"&page_size="+pagesize+"&page="+page,{ params:data })
}
//前端查询获取行业资讯内容 -- 张
getData.getSelectNews = (pk,pagesize,page,tags,data)=>{ 
    return http.get(baseUrl+"/one/front_knows/?k_type="+pk+"&page_size="+pagesize+"&page="+page+"&tags="+tags,{ params:data })
}
//前端查询获取热门七条行业资讯内容 -- 张
getData.getHotNews = (pk,data)=>{ 
    return http.get(baseUrl+"/one/front_knows/?k_type="+pk+"&hot=1",{ params:data })
}
//前端查询获取相关推荐六条行业资讯内容 -- 张
getData.getRelatedNews = (pk,data)=>{ 
    return http.get(baseUrl+"/one/front_knows/?k_type="+pk+"&related=1",{ params:data })
}
//我的信息选中的标签 -- 张
getData.myTags = (data)=>{ 
    return http.post(baseUrl+"/one/mytags/",data)
}
//前端查询获取收藏的行业资讯内容 -- 张
getData.getCollectNews = (pk,pagesize,page,data)=>{ 
    return http.get(baseUrl+"/one/front_knows/?k_type="+pk+"&page_size="+pagesize+"&page="+page+"&collect=1",{ params:data })
}
//前端查询获取关注的行业资讯内容 -- 张
getData.getBrowseNews = (pk,pagesize,page,data)=>{ 
    return http.get(baseUrl+"/one/front_knows/?k_type="+pk+"&page_size="+pagesize+"&page="+page+"&browse=1",{ params:data })
}



//获取知识库列表 -- 张 
getData.getKlistnows = (data)=>{ 
    return http.get(baseUrl+"/one/front_knowlibs/",{ params:data })
}
// ====================知识库/行业资讯头部搜索=====================
//根据文章标题和内容进行查询 -- 张
getData.getSelectTitleContenKnows = (data)=>{
    return http.get(baseUrl+"/one/knows_search/",{ params:data })
}



// ========================解决方案分类管理==========================
// 获取所有分类目录
getData.getStags = (data)=>{ 
    return http.get(baseUrl+"/solution/stags/",{ params:data })
}
// 获取单个分类目录
getData.getStag = (pk,data)=>{ 
    return http.get(baseUrl+"/solution/stag/"+pk+"/",{ params:data })
}
// 添加分类目录
getData.addStags = (data)=>{ 
    return http.post(baseUrl+"/solution/stags/",data)
}
// 修改单个分类目录
getData.editStag = (pk,data)=>{ 
    return http.patch(baseUrl+"/solution/stag/"+pk+"/",data)
}
// 删除单个分类目录
getData.deleteStag = (pk,data)=>{ 
    return http.delete(baseUrl+"/solution/stag/"+pk+"/",data)
}
// 批量删除分类目录
getData.deleteStags = (ids,data)=>{ 
    return http.delete(baseUrl+"/solution/stags/multi_del/?ids="+ids,data)
}
// ===========================解决方案列表页面=============================
// 获取所有解决方案
getData.getSolutions = (page,pageSize,title,user,stime,etime,data)=>{ 
    return http.get(baseUrl+"/solution/solutions/?page="+page+"&page_size="+pageSize+`${title?`&detail_title=${title}`:''}`+`${user?`&user=${user}`:''}`
    +`${stime?`&stime=${stime}`:''}`+`${etime?`&etime=${etime}`:''}`,{ params:data })
}
// 获取所有解决方案-header导航栏
getData.getHeaderSolutions = (data)=>{ 
    return http.get(baseUrl+"/solution/solutions/",{ params:data })
}
// 获取单个解决方案
getData.getSolution = (pk,data)=>{ 
    return new Promise((resolve, reject) => {
      http.get(baseUrl+"/solution/solution/"+pk+"/",{ params:data }).then((res) => {
          if(res.data.code == 200){
              let xx = res.data.data
                xx.detail_pic ? xx.detail_pic = xx.detail_pic.replace("/api", "/api/media"):xx.detail_pic;
                xx.arch_pic ? xx.arch_pic = xx.arch_pic.replace("/api", "/api/media"):xx.arch_pic;
                xx.advantage_pic ? xx.advantage_pic = xx.advantage_pic.replace("/api", "/api/media"):xx.advantage_pic;
                res.data.data=xx
                resolve(res)
          }else{
              resolve(res)
          }
      }).catch((err) => {
          reject(err)
      });
    })
    // return http.get(baseUrl+"/solution/solution/"+pk+"/",{ params:data })
}
// 添加单个解决方案
getData.addSolution = (data)=>{ 
    return http.post(baseUrl+"/solution/solutions/",data)
}
// 添加单个解决方案 -- 应用领域上传图片(暂时没用)
getData.addSolutionPic = (data)=>{ 
    return http.post(baseUrl+"/solution/areas/",data)
}
// 修改单个解决方案 -- 应用领域上传图片
getData.editSolution = (pk,data)=>{ 
    return http.patch(baseUrl+"/solution/solution/"+pk+"/",data)
}
// 删除单个解决方案 -- 应用领域上传图片
getData.deleteSolution = (pk,data)=>{ 
    return http.delete(baseUrl+"/solution/solution/"+pk+"/",data)
}
// 获取相关推荐解决方案
getData.getRecommend = (pk,data)=>{ 
    return http.get(baseUrl+"/solution/solutions/?recom=1&stags_id="+pk,{ params:data })
}








export default getData


// WEBPACK FOOTER //
// ./src/common/newEditionNewsKnow.js